import { NotifyTrigger as HeadlessNotifyTrigger } from '@coveo/headless';
import { useEffect, useState, FunctionComponent } from 'react';

interface HeadlessNotifyTriggerProps {
  controller: HeadlessNotifyTrigger;
}

export const NotifyTrigger: FunctionComponent<HeadlessNotifyTriggerProps> = (props) => {
  const { controller } = props;
  const [state, setState] = useState(controller.state);
  const [notifications, setNotifications] = useState('');

  useEffect(() => controller.subscribe(() => updateState()), []);
  useEffect(() => notificationsUpdated(), [state.notifications]);

  const updateState = () => {
    setState(props.controller.state);
  };

  const notificationsUpdated = () => {
    let note = '';
    state.notifications.forEach((notification) => {
      note += notification;
    });
    setNotifications(note);
  };

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: notifications }} style={{ paddingBottom: '10px' }}></div>
    </>
  );
};
